export default "__VITE_ASSET__bc107066__"